import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { EnumModel } from '../../models/enum.model';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FileURL } from '../../models/FileURL.model';
import { CalcApiService } from '../../services/calc-api.service';
import { Router } from '@angular/router';
import { StorageHelperService } from '../../services/storage-helper.service';
import { CalcfondRequestModel } from '../../models/calcfond-request.model';
import { CalcFondResponseModel } from '../../models/calcfond-response.model';
import { DatumiHelper } from '../../helpers/datum.helper';

@Component({
  selector: 'app-tarrif-calc-fond-junior',
  templateUrl: './tarrif-calc-fond-junior.component.html',
  styleUrls: ['./tarrif-calc-fond-junior.component.less']
})
export class TarrifCalcFondJuniorComponent implements OnInit {

  Resultsmodal = false;

  tarifa = ''

  // Age combo
  showAgeDrop = false;
  disableAgeCombo = false;
  insuranceAge: EnumModel = new EnumModel(null, '');
  ageSource: EnumModel[] = [];
  ageErrorMessage = '';

  // duration combo
  showDurationDrop = false;
  disableDurationCombo = false;
  insuranceDuration: EnumModel = new EnumModel(null, '');
  durationSource: EnumModel[] = [];
  durationErrorMessage = '';

  // Payment combo
  showPaymenteDrop = false;
  disablePaymentCombo = false;
  insurancePayment: EnumModel = new EnumModel(null, '');
  PaymentSource: EnumModel[] = [];
  PaymentErrorMessage = '';

  // PSPercent
  showPSPercentDrop = false;
  disablePSPercentCombo = false;
  insurancePSPercent: EnumModel = new EnumModel(null, '');
  PSPercentSource: EnumModel[] = [];
  PSPercentErrorMessage = '';

   // Gender combo
   showGenderDrop = false;
   disableGenderCombo = false;
   insuranceGender: EnumModel = new EnumModel(null, '');
   GenderSource: EnumModel[] = [];
   GenderErrorMessage = '';


  // v1
  showv1Drop = false;
  disablev1Combo = false;
  insurancev1: EnumModel = new EnumModel(null, '');
  v1Source: EnumModel[] = [];
  v1ErrorMessage = '';

  // v2
  showv2Drop = false;
  disablev2Combo = false;
  insurancev2: EnumModel = new EnumModel(null, '');
  v2Source: EnumModel[] = [];
  v2ErrorMessage = '';

  // v3
  showv3Drop = false;
  disablev3Combo = false;
  insurancev3: EnumModel = new EnumModel(null, '');
  v3Source: EnumModel[] = [];
  v3ErrorMessage = '';

  // v4
  showv4Drop = false;
  disablev4Combo = false;
  insurancev4: EnumModel = new EnumModel(null, '');
  v4Source: EnumModel[] = [];
  v4ErrorMessage = '';

  // v5
  showv5Drop = false;
  disablev5Combo = false;
  insurancev5: EnumModel = new EnumModel(null, '');
  v5Source: EnumModel[] = [];
  v5ErrorMessage = '';

  // option
  PrToVs = true;
  VsToPr = false;

  calcfondRequestModel: CalcfondRequestModel = new CalcfondRequestModel();
  calcFondResponseModel: CalcFondResponseModel = new CalcFondResponseModel();
  userForm: FormGroup;

  fileURL: FileURL = new FileURL();
  loader = false;

  type: string;

  statNr: number;
  Psum: number;


  constructor(private webShopApiService: CalcApiService, private router: Router, private fb: FormBuilder) {

    this.userForm = fb.group({
      'OValue': [null],
    });

//    this.PaymentSource.push(new EnumModel(1, '0'));
    // this.PaymentSource.push(new EnumModel(2, 'Полугодишно'));


    this.PaymentSource.push(new EnumModel(1, 'Годишно плаќање'));
    this.PaymentSource.push(new EnumModel(2, 'Полугодишно плаќање'));
    this.PaymentSource .push(new EnumModel(4, 'Тримесечно плаќање'));
    this.PaymentSource .push(new EnumModel(12, 'Месечно плаќање'));

    this.insurancePayment = new EnumModel(1, 'Годишно плаќање');

    this.PSPercentSource.push(new EnumModel(10, '10%'));
    //this.PSPercentSource.push(new EnumModel(100, '100%'));

    this.insurancePSPercent = new EnumModel(10, '10%');

    //this.calcfondRequestModel = StorageHelperService.GetData('CalcRequestModel');

    //if (!this.calcfondRequestModel) {
    //  this.router.navigate(['home']);
    //}

  }

  ngOnInit() {

    this.tarifa = localStorage.getItem('type');
    localStorage.removeItem('type')

    if (this.calcfondRequestModel == null) {
      this.router.navigate(['TarrifChoos'], { queryParams: { type: this.type}, queryParamsHandling: 'merge' });
    }
     sessionStorage.clear();
    this.initAge();
    this.initv1();
    this.initv2();
    this.initv3();
    this.initv4();
    this.initv5();
    this.initGender();


  }



  changedurationByAge() {

    const currentYear = DatumiHelper.racunajgodinu(false);
    this.durationSource  = [];

    const Age = currentYear - this.insuranceAge.id;   


    const AgeReCalc = 26 - Age;
    if (Age === 0) {
      for (let i = 10; i <= 26; i++) {
        this.durationSource.push(new EnumModel(i, String(i)));
      }
    } else if (Age >= 1 && Age <= 16) {
      for (let i = 10; i <= AgeReCalc; i++) {
        this.durationSource.push(new EnumModel(i, String(i)));
      }
    }

  }

  changePSByPayment() {
    this.PSPercentSource  = [];
    const Payment = this.insurancePayment.id;
    if (Payment === 0) {
     // this.PSPercentSource.push(new EnumModel(100, '100%'));
     // this.insurancePSPercent = new EnumModel(100, '100%');
    }  else {
      this.PSPercentSource.push(new EnumModel(10, '10%'));
     // this.PSPercentSource.push(new EnumModel(100, '100%'));

      this.insurancePSPercent = new EnumModel(10, '10%');
    }

  }

  selectInsuranceDuration(duration: EnumModel) {
    this.durationErrorMessage = '';
    this.insuranceDuration = duration;
    this.showDurationDrop = false;
  }

  onClickOutsideDurationCombo(event: Object) {
    if (event && event['value'] === true) {
      this.showDurationDrop = false;
    }
  }

  durationComboEvent() {
    if (!this.disableDurationCombo) {
      this.showDurationDrop = !this.showDurationDrop;
    }
  }

  initAge() {

    const currentYear = DatumiHelper.racunajgodinu(false);

    const AgeFrom =  currentYear - 16;
    const AgeTo = currentYear - 0;
    for (let i = AgeFrom; i <= AgeTo; i++) {
      this.ageSource.push(new EnumModel(i, String(i)));
    }

    this.insuranceAge = new EnumModel(AgeFrom, String(AgeFrom));
    
    // for (let i = 10; i <= 26; i++) {
    //   this.durationSource.push(new EnumModel(i, String( i)));
    // }
    this.insuranceDuration = new EnumModel(10, String(10));
  }



  selectInsuranceAge(duration: EnumModel) {
    this.ageErrorMessage = '';
    this.insuranceAge = duration;
    this.showAgeDrop = false;
  }

  onClickOutsideAgeCombo(event: Object) {
    if (event && event['value'] === true) {
      this.showAgeDrop = false;
    }
  }

  AgeComboEvent() {
    if (!this.disableDurationCombo) {
      this.showAgeDrop = !this.showAgeDrop;
    }
  }


  selectInsurancePayment(duration: EnumModel) {
    this.PaymentErrorMessage = '';
    this.insurancePayment = duration;
    this.showPaymenteDrop = false;
  }

  onClickOutsidePaymentCombo(event: Object) {
    if (event && event['value'] === true) {
      this.showPaymenteDrop = false;
    }
  }

  PaymentComboEvent() {
    if (!this.disablePaymentCombo) {
      this.showPaymenteDrop = !this.showPaymenteDrop;
    }
  }


  selectInsurancePS(duration: EnumModel) {
    this.PSPercentErrorMessage = '';
    this.insurancePSPercent = duration;
    this.showPSPercentDrop = false;
  }
  onClickOutsidePSCombo(event: Object) {
    if (event && event['value'] === true) {
      this.showPSPercentDrop = false;
    }
  }
  PSComboEvent() {
    if (!this.disablePSPercentCombo) {
      this.showPSPercentDrop = !this.showPSPercentDrop;
    }
  }

   // Gender

   initGender() {
    this.GenderSource.push(new EnumModel(1, String('женско')));
    this.GenderSource.push(new EnumModel(0, String('машко')));


    this.insuranceGender = new EnumModel(0, String('машко'));
  }

  selectInsuranceGender(duration: EnumModel) {
    this.GenderErrorMessage = '';
    this.insuranceGender = duration;
    this.showGenderDrop = false;
  }
  onClickOutsideGenderCombo(event: Object) {
    if (event && event['value'] === true) {
      this.showGenderDrop = false;
    }
  }
  GenderComboEvent() {
    if (!this.disableGenderCombo) {
      this.showGenderDrop = !this.showGenderDrop;
    }
  }


  // Variants
// Variant 1

  initv1() {
    this.v1Source.push(new EnumModel(0, String(0)));
    this.v1Source.push(new EnumModel(5000, String(5000)));
    this.v1Source.push(new EnumModel(10000, String(10000)));
    this.v1Source.push(new EnumModel(20000, String(20000)));

    this.insurancev1 = new EnumModel(0, String(0));
  }

  selectInsurancev1(duration: EnumModel) {
    this.v1ErrorMessage = '';
    this.insurancev1 = duration;
    this.showv1Drop = false;
  }
  onClickOutsidev1Combo(event: Object) {
    if (event && event['value'] === true) {
      this.showv1Drop = false;
    }
  }
  v1ComboEvent() {
    if (!this.disablev1Combo) {
      this.showv1Drop = !this.showv1Drop;
    }
  }


  // Variant 2

  initv2() {
    this.v2Source.push(new EnumModel(0, String('0')));
    this.v2Source.push(new EnumModel(1500, String('1500')));
    this.v2Source.push(new EnumModel(3000, String('3000')));
    this.v2Source.push(new EnumModel(5000, String('5000')));

    this.insurancev2 = new EnumModel(0, String('0'));

  }

  selectInsurancev2(duration: EnumModel) {
    this.v2ErrorMessage = '';
    this.insurancev2 = duration;
    this.showv2Drop = false;
  }
  onClickOutsidev2Combo(event: Object) {
    if (event && event['value'] === true) {
      this.showv2Drop = false;
    }
  }
  v2ComboEvent() {
    if (!this.disablev2Combo) {
      this.showv2Drop = !this.showv2Drop;
    }
  }

  // Variant 3

  initv3() {
    this.v3Source.push(new EnumModel(0, String(0)));
    this.v3Source.push(new EnumModel(5, String(5)));
    this.v3Source.push(new EnumModel(10, String(10)));
    this.v3Source.push(new EnumModel(20, String(20)));

    this.insurancev3 = new EnumModel(0, String(0));
  }

  selectInsurancev3(duration: EnumModel) {
    this.v3ErrorMessage = '';
    this.insurancev3 = duration;
    this.showv3Drop = false;
  }
  onClickOutsidev3Combo(event: Object) {
    if (event && event['value'] === true) {
      this.showv3Drop = false;
    }
  }
  v3ComboEvent() {
    if (!this.disablev3Combo) {
      this.showv3Drop = !this.showv3Drop;
    }
  }

  // Variant 4

  initv4() {
    this.v4Source.push(new EnumModel(0, String(0)));
    this.v4Source.push(new EnumModel(5, String(5)));
    this.v4Source.push(new EnumModel(10, String(10)));
    this.v4Source.push(new EnumModel(20, String(20)));

    this.insurancev4 = new EnumModel(0, String(0));
  }

  selectInsurancev4(duration: EnumModel) {
    this.v4ErrorMessage = '';
    this.insurancev4 = duration;
    this.showv4Drop = false;
  }
  onClickOutsidev4Combo(event: Object) {
    if (event && event['value'] === true) {
      this.showv4Drop = false;
    }
  }
  v4ComboEvent() {
    if (!this.disablev4Combo) {
      this.showv4Drop = !this.showv4Drop;
    }
  }

  // Variant 5

  initv5() {
    this.v5Source.push(new EnumModel(0, String(0)));
    this.v5Source.push(new EnumModel(1500, String(1500)));
    this.v5Source.push(new EnumModel(3000, String(3000)));
    this.v5Source.push(new EnumModel(5000, String(5000)));

    this.insurancev5 = new EnumModel(0, String(0));
  }

  selectInsurancev5(duration: EnumModel) {
    this.v5ErrorMessage = '';
    this.insurancev5 = duration;
    this.showv5Drop = false;
  }
  onClickOutsidev5Combo(event: Object) {
    if (event && event['value'] === true) {
      this.showv5Drop = false;
    }
  }
  v5ComboEvent() {
    if (!this.disablev5Combo) {
      this.showv5Drop = !this.showv5Drop;
    }
  }



  togglePrVS() {
    // this.errorMessage = '';
    this.PrToVs = !this.PrToVs;
    this.VsToPr = false;
  }

  toggleVsPr() {

    this.VsToPr = !this.VsToPr;
    this.PrToVs = false;
  }



  submitCalc() {
    this.loader = true;
    if (this.insurancePayment.id === 0) {
      this.Psum = this.userForm.controls['OValue'].value;
    } else {
      this.Psum = this.userForm.controls['OValue'].value * this.insurancePayment.id  *  this.insuranceDuration.id;
    }

    if(this.type == 'ГРАВЕ ИНВЕСТ Јуниор'){
        if (this.insurancePayment.id === 0) {
          this.statNr  = 11;
        } else {
          this.statNr = 1;
        }
    }else{

        if (this.insurancePayment.id === 0) {
          this.statNr  = 111;
        } else {
          this.statNr = 101;
        }
    }




    this.calcfondRequestModel.Statistiknummer = this.statNr;
    this.calcfondRequestModel.VersDauer = this.insuranceDuration.id;
    this.calcfondRequestModel.OptimizeValue =  this.Psum;
    this.calcfondRequestModel.Zahlweise = this.insurancePayment.id;
    this.calcfondRequestModel.YearOfBirth = this.insuranceAge.id;
    this.calcfondRequestModel.AblSumPercent = this.insurancePSPercent.id;
    this.calcfondRequestModel.Geschlecht_VP1 = this.insuranceGender.id;
    this.calcfondRequestModel.HIOs =  this.insurancev2.id;
   
    // this.calcRequestModel.Variant_1 = this.insurancev1.id;
    // this.calcRequestModel.Variant_2 = this.insurancev2.id;
    // this.calcRequestModel.Variant_3 = this.insurancev3.id;
    // this.calcRequestModel.Variant_4 = this.insurancev4.id;
    // this.calcRequestModel.Variant_5 = this.insurancev5.id;

    this.webShopApiService.calculatefondJunior(this.calcfondRequestModel)
      .subscribe(
        (response) => {
          this.loader = false;
          this.calcFondResponseModel = new CalcFondResponseModel();
          this.calcFondResponseModel = response;
          // StorageHelperService.PullData('CalcRequestModel');
          // StorageHelperService.PushData('CalcRequestModel', this.calcRequestModel);
          // // StorageHelperService.PushData('calcResponseModel', this.calcResponseModel);
          // this.router.navigate(['CalcResultsComponent'], { queryParams: { type: this.type}, queryParamsHandling: 'merge' });
          this.loader = false;

        },
        (error) => {
          console.log(error);
          this.loader = false;
        }
      );

      window.scroll(0, 0);

      this.Resultsmodal = true;
   }


  downloadInfoPdf() {
    // this.loader = true;
    // this.webShopApiService.downloadpdf(this.calcResponseModel)
    //   .subscribe(
    //     (response) => {
    //       this.fileURL = response;
    //       // const fileUrl = response;
    //       const a = document.createElement('a');
    //       document.body.appendChild(a);
    //       a.setAttribute('style', 'display: none');
    //       a.setAttribute('target', '_blank');
    //       a.href = this.fileURL.fileURL;
    //       a.click();
    //       a.remove();
    //       this.loader = false;
    //     },
    //     (error) => {
    //       this.loader = false;
    //     }
    //   );
  }

  downloadInfoPdfFinalOffer() {
    // this.loader = true;
    // this.webShopApiService.downloadpdfoffer(this.calcResponseModel)
    //   .subscribe(
    //     (response) => {
    //       this.fileURL = response;
    //       // const fileUrl = response;
    //       const a = document.createElement('a');
    //       document.body.appendChild(a);
    //       a.setAttribute('style', 'display: none');
    //       a.setAttribute('target', '_blank');
    //       a.href = this.fileURL.fileURL;
    //       a.click();
    //       a.remove();
    //       this.loader = false;
    //     },
    //     (error) => {
    //       this.loader = false;
    //     }
    //   );

  }
  downloadadviceprotocol() {
    // // this.loader = true;
    //
    // const fileUrl = 'https://grawepower.rs/gpower/bgibox/docs/adviceprotocol.pdf';
    // const a = document.createElement('a');
    // document.body.appendChild(a);
    // a.setAttribute('style', 'display: none');
    // a.setAttribute('target', '_blank');
    // a.href = fileUrl;
    // a.click();
    // a.remove();
    // //   this.loader = false;
  }

  downloadKID() {
    // // this.loader = true;
    //
    // const fileUrl = 'https://grawepower.rs/gpower/bgibox/docs/capital_kid_20180101_gab11.pdf';
    // const a = document.createElement('a');
    // document.body.appendChild(a);
    // a.setAttribute('style', 'display: none');
    // a.setAttribute('target', '_blank');
    // a.href = fileUrl;
    // a.click();
    // a.remove();
    //   this.loader = false;
  }

  downloadGTC() {
    // // this.loader = true;
    //
    const fileUrl = 'https://www.grawe.mk/fileadmin/grawe_mk/Downloads/Uslovi_FLV_AVB_2018__izmena_2020.pdf';
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.setAttribute('style', 'display: none');
    a.setAttribute('target', '_blank');
    a.href = fileUrl;
    a.click();
    a.remove();
    // //   this.loader = false;
  }

  downloadPrecontractinfo() {
    // // this.loader = true;
    //
    // const fileUrl = 'https://grawepower.rs/gpower/bgibox/docs/precontract_info.pdf';
    // const a = document.createElement('a');
    // document.body.appendChild(a);
    // a.setAttribute('style', 'display: none');
    // a.setAttribute('target', '_blank');
    // a.href = fileUrl;
    // a.click();
    // a.remove();
    // //   this.loader = false;
  }






}



// WEBPACK FOOTER //
// ./src/app/pages/tarrif-calc-fond-junior/tarrif-calc-fond-junior.component.ts